import './ItemFileCard.css';

import React, { useEffect, useState } from 'react';
import { truncateText } from '../../../b2b-common/helpers';
import { MoreVert, Star } from '@mui/icons-material';
import MoreButton from '../../../b2b-common/MoreButton';
import MimeIcon from './MimeIcon';
import IconWithTooltip from '../../../b2b-common/IconWithTooltip';
import FileSizeComponent from './FileSizeComponent';
import ConfirmationDialog from '../../../b2b-common/ConfirmationDialog';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const ItemFileCard = ({ item, onClick, onEdit, onDelete }) => {

    const { t } = useB2BTranslation('b2b-logbook');

    const [currentItem, setCurrentItem] = useState(item);
    const [isHovered, setIsHovered] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    useEffect(() => {
        setCurrentItem(item);
    }, [item]);

    const handleClick = () => {
        onClick && onClick(currentItem);
    }

    const handleEdit = () => {
        onEdit && onEdit(currentItem);
    }

    const handleDelete = () => {
        onDelete && onDelete(currentItem);
        setShowDeleteConfirmation(false);
    }

    return (
        <div className='item-card-container'
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleClick}
        >
            <div className='item-card-icon-name'>
                <MimeIcon mime={currentItem.logBookItemFileMime} />
                <div className='item-card-name'>
                    {currentItem.logBookItemName}
                </div>
            </div>
            <div className='item-card-info'>
                <div className='item-card-description'>
                    {truncateText(currentItem.logBookItemDescription, 20)}
                </div>
            </div>
            {currentItem.logBookItemStarred && (
                <IconWithTooltip IconComponent={Star} tooltip={t('Starred')} className='item-card-star' />
            )}
            <FileSizeComponent size={currentItem.logBookItemFileSize} className='item-card-file-size' />
            {isHovered && (
                <MoreButton icon={<MoreVert />} className={'item-card-more-button'}
                    dropPositionAlign='right'
                    buttons={[
                        {
                            label: t('Edit'),
                            onClick: handleEdit,
                        },
                        {
                            label: t('Delete'),
                            onClick: () => setShowDeleteConfirmation(true),
                        }
                    ]}
                    rolesAllowed={['ADMIN', 'EDITOR']}
                    b2bProducts={['B2B_LOGBOOK']}
                />
            )}
            <ConfirmationDialog
                title={t('Item Delete Confirmation Request')}
                mainText={t('Are you sure you want to delete this item?')}
                open={showDeleteConfirmation}
                onClose={() => setShowDeleteConfirmation(false)}
                onConfirm={handleDelete}
            />
        </div>
    );
}

export default ItemFileCard;